import React, { useState, useEffect } from "react";

// components
import StatisticsChartWidget2 from "./StatisticsChartWidget2 ";

import axios from "axios";
import { BASE_URL, security_key } from "../../global";
const NewUsers = () => {
    // State for the selected filter
    const [loading, setLoading] = useState(false);

    const [weekData, setWeekData] = useState({});
    const [monthData, setMonthData] = useState({});
    const [yearData, setYearData] = useState({});
    const [reuserData, setReuserData] = useState({});

    useEffect(() => {
        getAdminNewUserChartData();
    }, []);

    const getAdminNewUserChartData = async () => {
        try {
            setLoading(true);

            const response = await axios.post(`${BASE_URL}API/apicall`, {
                security_key,
                mode: "getAdminNewUserChartData",
                pk_user_key: sessionStorage.getItem("pk_user_key"),
            });

            const output = response.data;
            if (Object.keys(output).length > 0) {
                setWeekData({
                    weekArr: output["weekData"].map((row) => row.week),
                    countArr: output["weekData"].map((row) => row.reg_count),
                });
                setMonthData({
                    monthArr: output["monthData"].map((row) => row.month),
                    countArr: output["monthData"].map((row) => row.reg_count),
                });
                setYearData({
                    yearArr: output["yearData"].map((row) => row.year),
                    countArr: output["yearData"].map((row) => row.reg_count),
                });
                setReuserData({
                    yearArr: output["reuserData"].map((row) => row.month),
                    countArr: output["reuserData"].map((row) => row.reg_count),
                });
            } else {
                // toast.error("Oops! Something went wrong.", { autoClose: 3000 });
            }
        } catch (error) {
            // toast.error("Error adding article: " + error.message);
        } finally {
            setLoading(false);
        }
    };

    const sum = (a) => eval(a.join("+"));

    return (
        <div className="card border-0 h-100">
            <div className="card-body">
                <div className="dropdown float-end">
                    <a
                        className="dropdown-toggle cursor-pointer arrow-none p-0 text-dark"
                        href="#"
                        role="button"
                        id="dropdownMenuLink"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                    >
                        <i className="uil uil-ellipsis-v fs-13"></i>
                    </a>
                    <ul className="dropdown-menu" aria-labelledby="dropdownMenuLink">
                        <li>
                            <a className="dropdown-item" href="#" onClick={getAdminNewUserChartData}>
                                <i className="uil uil-refresh me-2"></i>Refresh Report
                            </a>
                        </li>
                        {/* <li>
                            <a className="dropdown-item" href="#">
                                <i className="uil uil-export me-2"></i>Export Report
                            </a>
                        </li> */}
                    </ul>
                </div>

                <h4 className="card-title header-title">New Users</h4>

                <StatisticsChartWidget2
                    title="New users this week"
                    stats={weekData["countArr"] && sum(weekData["countArr"])}
                    containerClass="border-bottom justify-content-between align-items-end pb-3"
                    // trend={{
                    //     textClass: "text-success",
                    //     value: "+17.98%",
                    // }}
                    colors={["#3C3D37"]}
                    // data={[25, 66, 41, 89, 63, 25, 44, 12, 36, 9, 54]}
                    // data={[25, 66, 41, 89, 63, 25, 44]}
                    data={weekData["countArr"]}
                    // options={{
                    //     scales: {
                    //         y: {
                    //             beginAtZero: true,
                    //             ticks: {
                    //                 stepSize: 10,
                    //                 min: 0,
                    //             },
                    //             title: {
                    //                 display: true,
                    //                 text: "Users",
                    //             },
                    //         },
                    //         x: {
                    //             type: "category", // Define as category scale
                    //             labels: ["Week 1", "Week 2", "Week 3", "Week 4", "Week 5"], // Custom labels for x-axis
                    //         },
                    //     },
                    // }}
                />

                <StatisticsChartWidget2
                    title="New users this month"
                    stats={monthData["countArr"] && sum(monthData["countArr"])}
                    containerClass="border-bottom justify-content-between align-items-end py-3"
                    // trend={{
                    //     textClass: "text-success",
                    //     value: "+24.98%",
                    // }}
                    type="line"
                    colors={["#3C3D37"]}
                    // data={[25, 66, 41, 89, 63, 25, 44, 12, 36, 9, 54, 25, 66, 41, 89, 63, 25, 44, 12, 36, 9, 54, 25, 66, 41, 89, 63, 25, 44, 12, 36, 9, 54]}
                    data={monthData["countArr"]}
                />

                <StatisticsChartWidget2
                    title="New users this year"
                    stats={yearData["countArr"] && sum(yearData["countArr"])}
                    containerClass="border-bottom justify-content-between align-items-end py-3"
                    // trend={{
                    //     textClass: "text-success",
                    //     value: "+39.52%",
                    // }}
                    colors={["#3C3D37"]}
                    // data={[25, 66, 41, 89, 63, 25, 44, 12, 36, 9, 54]}
                    data={yearData["countArr"]}
                />

                <StatisticsChartWidget2
                    title="Returning users"
                    stats={reuserData["countArr"] && sum(reuserData["countArr"])}
                    containerClass="justify-content-between align-items-end border-bottom py-3"
                    // trend={{
                    //     textClass: "text-danger",
                    //     value: "-26.47%",
                    // }}
                    type="line"
                    colors={["#3C3D37"]}
                    // data={[25, 66, 41, 89, 63, 25, 44, 12, 36, 9, 54]}
                    data={reuserData["countArr"]}
                />
            </div>
            <style jsx>
                {`
                    @media screen and (max-width: 2560px) {
                        .dropdown-menu {
                            transform: translate3d(-155px, 20px, 0px);
                        }
                    }
                `}
            </style>
        </div>
    );
};

export default NewUsers;
